import {
  LocaleSelect,
  useI18nContext,
  type IPP_SUPPORTED_LOCALE,
} from '@retailer-platform/shared-components'
import { useCurrentAccountContext } from '@retailer-platform/dashboard/utils'

export const PostLoginLocaleSelect = () => {
  const { locale, setLocale } = useI18nContext()
  const { account } = useCurrentAccountContext()

  return (
    <LocaleSelect
      compact={false}
      defaultLocale={(account?.userLocale as IPP_SUPPORTED_LOCALE) || locale.replace('-', '_')}
      onChange={locale => {
        setLocale(locale.localeCode.replace('_', '-') as IPP_SUPPORTED_LOCALE)
      }}
      value={locale.replace('-', '_')}
    />
  )
}
